import React, { useRef } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Button, message } from 'antd'

import validateBillingInfo from 'containers/settings/billing/payment/billing-info/modal/validate'
import Content from 'components/layout/content'
import BillingForm from './billing-form'
import { useAccountRoutes } from 'containers/routes'
import { useGetCustomerQuery, useUpdateCustomerQuery, useValidateVatQuery } from 'hooks/api'

import styles from './styles.module.less'

const EditBilling = () => {
  const history = useHistory()
  const { customerId } = useParams()
  const routes = useAccountRoutes()

  const { data: customer, isLoading: loading } = useGetCustomerQuery({ customerId })

  const { mutateAsync: editBilling, isLoading: saving } = useUpdateCustomerQuery()
  const { mutateAsync: validateVAT } = useValidateVatQuery()

  const formRef = useRef()

  const handleUpdateBilling = async () => {
    const billingInfo = await validateBillingInfo(formRef?.current)

    if (!billingInfo) {
      return null
    }

    try {
      await editBilling({ identity: customerId, payload: billingInfo })
      message.success('Billing info updated successfully.')
      return history.push(routes.settings.payment.url())
    } catch (error) { message.error('Something went wrong') }
  }

  return (
    <Content item title='Edit billing' loading={loading} backRoute={routes.settings.payment.url()} breadcrumbs={['settings', 'payment-methods', 'edit']}>
      <BillingForm customer={customer} ref={formRef} validateVat={validateVAT} />
      <Button className={styles.save_btn} type='primary' loading={saving} onClick={() => handleUpdateBilling()}>Save</Button>
      <Button type='link' onClick={history.goBack}>Cancel</Button>
    </Content>
  )
}

export default EditBilling
